import { CIcon } from '~/icons/types'

export const ciUndo: CIcon = {
  width: '24',
  height: '24',
  paths: [
    {
      d:
        'M21.998 9.002a10.554 10.554 0 0 0-4.033-5.558 10.536 10.536 0 0 0-6.604-1.877 10.559 10.559 0 0 0-6.364 2.616L4.5 4.63V2a1.5 1.5 0 1 0-3 0v6c0 .159.031.308.077.452l.018.059c.063.173.157.33.276.467.006.007.008.017.014.024.004.005.01.006.014.011.126.137.278.25.448.332l.027.015c.16.074.335.117.52.13.015 0 .029.003.044.004.021.001.041.006.062.006h6a1.5 1.5 0 1 0 0-3H6.907l.085-.076a7.536 7.536 0 0 1 4.538-1.861 7.52 7.52 0 0 1 4.717 1.341 7.532 7.532 0 0 1 2.881 3.969 7.542 7.542 0 0 1-.188 4.901 7.526 7.526 0 0 1-3.177 3.736 7.558 7.558 0 0 1-4.807.976 7.538 7.538 0 0 1-4.381-2.205 7.525 7.525 0 0 1-2.082-4.44 1.5 1.5 0 0 0-2.983.317 10.545 10.545 0 0 0 2.915 6.216 10.542 10.542 0 0 0 6.134 3.086 10.563 10.563 0 0 0 6.73-1.364 10.542 10.542 0 0 0 4.446-5.23c.85-2.182.943-4.621.263-6.864Z'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'undo',
  type: 'solid'
}
